module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-pagination-item",
    class: {
      'circle': _vm.isCircle,
      'active': _vm.isActive
    },
    attrs: {
      "wrapperClass": "mu-pagination-item-wrapper",
      "centerRipple": false,
      "disabled": _vm.disabled,
      "containerElement": "div"
    },
    on: {
      "click": _vm.handleClick,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [(_vm.index) ? _c('span', [_vm._v(_vm._s(_vm.index))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2394f41b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/pagination/pageItem.vue
// module id = 3639
// module chunks = 1